exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".locator-widget{height:37.5rem;width:100%}.locator-widget svg{vertical-align:inherit}", ""]);

